function installGetRootNodePolyfill () {
  if (typeof window === 'undefined') return

  var NodeCtor = window.Node
  if (!NodeCtor || !NodeCtor.prototype || NodeCtor.prototype.getRootNode) return

  Object.defineProperty(NodeCtor.prototype, 'getRootNode', {
    configurable: true,
    writable: true,
    value: function getRootNode () {
      var node = this
      while (node && node.parentNode) {
        node = node.parentNode
      }
      return node || window.document
    }
  })
}

installGetRootNodePolyfill()
